module.exports = __webpack_public_path__ + "img/tech6.18ada42d.webp";